<template lang="pug">
.section.section--white
	.donation-form
		form(@submit.prevent="send")
			p.sf-text(v-if="formState==FORM_STATES.FORM") Kérjük, adja meg az adományozáshoz szükséges alábbi információkat, majd átirányítjuk a SimplePay bankkártyás fizetési oldalára, ahol bankkártya adatainak megadásával véglegesítheti adományát.
			fieldset
				legend.sf-heading-2 Adományozás adatok
				.form-row
					.form-col
						label#donation-project-guid-label(for="donation-project-guid") Támogatott projekt
					.form-col
						VueInput(v-model="model.projectName", id="donation-project-guid", :max-width="352", :max-length="50", readonly="true", tabindex="-1")
				.form-row
					.form-col
						label#donation-merchant-name-label(for="donation-merchant-name") Támogatott szervezet
					.form-col
						VueInput(v-model="model.merchantName", id="donation-merchant-name", :max-width="352", :max-length="50", readonly="true", tabindex="-1")
				.form-row
					.form-col
						label(for="donation-donated-amount") Mekkora összeget adományozna?
					.form-col
						VueRadioGroup(id="donation-donated-amount" v-model="amount", legend="", :isLegendHidden="true", :verticalAlign="true", :options="AMOUNT_VALUES")
				.dropdown-field.dropdown-field--arrow(v-if="amount=='OTHER'")
					svg.dropdown-arrow(width="32", height="16", viewbox="0 0 32 16", fill="none", xmlns="http://www.w3.org/2000/svg", aria-hidden="true")
						path(fill-rule="evenodd", clip-rule="evenodd", d="M13.6286 1.96444C13.8848 0.850958 14.8574 0 16 0C17.1426 0 18.1152 0.85096 18.3714 1.96444C19.3548 6.23822 22.6268 16 32 16H0C9.37315 16 12.6452 6.23822 13.6286 1.96444Z", fill="#EFF2F9")
					.dropdown-field-container
						.form-row
							.form-col
								label(for="donation-donated-other-amount") Összeg
							.form-col
								VueCurrencyInput(
									id="donation-donated-other-amount",
									v-model="amountOther"
									:max-width="174",
									:max-length="50"
									postfix="Ft",
									:has-error="hasError('amountOther')",
									@blur="$v.amountOther.$touch()",
									aria-describedby="donation-donated-other-amount-error",
									:aria-invalid="hasError('amountOther')"
								)
								VueErrorMessage(id="donation-donated-other-amount-error", v-if="hasError('amountOther', 'required')", position="bottom") Kérjük, adja meg az összeget!

			fieldset
				legend.sf-heading-2 Adományozó adatai &nbsp;
					VueTooltip(placement="bottom", distance="8")
						span(slot="content")
							p Személyes adataira a SimplePay fizetéshez van szükség, nem marketing célra használjuk fel.
				.form-row
					.form-col
						label#donation-donator-name-label(for="donation-donor") Neve
					.form-col
						VueInput(v-model="model.donorName", id="donation-donor", :max-width="352", :max-length="50", :has-error="hasError('model.donorName')", @blur="$v.model.donorName.$touch()", aria-describedby="donation-donor-error", :aria-invalid="hasError('model.donorName')")
						VueErrorMessage(id="donation-donor-error", v-if="hasError('model.donorName', 'required')", position="bottom") Kérjük, adja meg a nevét!
				.form-row
					.form-col
						label#donation-donator-email-label(for="donation-donator-email") E-mail címe
					.form-col
						VueInput(v-model="model.email", id="donation-donator-email", :max-width="352", :max-length="50", :has-error="hasError('model.email')", @blur="$v.model.email.$touch()", aria-describedby="donation-donator-email-error", :aria-invalid="hasError('model.email')")
						VueErrorMessage(id="donation-donator-email-error", v-if="hasError('model.email', 'required')", position="bottom") Kérjük, adja meg e-mail címét!
						VueErrorMessage(id="donation-donator-email-error", v-if="hasError('model.email', 'email')", position="bottom") Kérjük, ellenőrizze az e-mail címet!
				.form-row
					.form-col
						label#donation-donator-mobile-phone-label(for="donation-donator-mobile-phone-input") Mobiltelefonszáma
					.form-col
						VueMobilephoneInput(id="donation-donator-mobile-phone-input", v-model="model.phoneNumber", :max-width="176", prefix="+36", addon="pl.: +36 XX 123 4567", :has-error="hasError('model.phoneNumber')", @blur="$v.model.phoneNumber.$touch()", aria-describedby="donation-donator-mobile-phone-error", :aria-invalid="hasError('model.phoneNumber')")
						VueErrorMessage(id="donation-donator-mobile-phone-error", v-if="hasError('model.phoneNumber', 'required')", position="bottom") Kérjük, adja meg a telefonszámát!
						VueErrorMessage(id="donation-donator-mobile-phone-error", v-if="hasError('model.phoneNumber', 'pattern')", position="bottom") Kérjük, ellenőrizze a telefonszámot!
				.form-row(v-if="captchaImg")
					.form-col
						label#donation-captcha-label(for="donation-captcha-input") Írja be a képen látható kódot
					.form-col
						VueCaptcha(id="donation-captcha-input", :img="'data:image/png;base64,' + captchaImg", v-model="model.captchaText", :max-width="104", :has-error="hasError('model.captchaText') || captchaError", @keyup="$emit('captcha-keyup')", @blur="$v.model.captchaText.$touch()", aria-describedby="donation-captcha-error", :aria-invalid="hasError('model.captchaText')")
						VueErrorMessage(id="donation-captcha-error" v-if="hasError('model.captchaText', 'required')", position="bottom") Kérjük, adja meg a képen látható kódot!
						VueErrorMessage(id="donation-captcha-error" v-if="captchaError" position="bottom") Kérjük, ellenőrizze a képen látható kódot!
				hr(aria-hidden="true")
				.form-row
					VueCheckbox(id="donation-accept-privacy-statement-checkbox", v-model="acceptPrivacyStatement", :has-error="hasError('acceptPrivacyStatement')", @blur="$v.acceptPrivacyStatement.$touch()", aria-labelledby="donation-accept-privacy-statement-checkbox", aria-describedby="donation-accept-privacy-statement-error", :aria-invalid="hasError('acceptPrivacyStatement')")
						slot(name="legal-block")
					VueErrorMessage(id="donation-accept-privacy-statement-error", v-if="hasError('acceptPrivacyStatement', 'checked')", position="bottom") Kérjük, olvassa el és fogadja el az adatkezelési tájékoztatót!
				.form-row.form-row--submit-button
					vue-button(type="submit")
						span(v-if="isMobile") Tovább a SimplePay fizetésre
						span(v-if="!isMobile") Tovább a SimplePay fizetői felületre
				a.form-row--simplepay(href="http://simplepay.hu/vasarlo-aff", target="_blank")
					img.logo-cards(src="../../../assets/img/application/donation/simplepay-logo-cards.webp", alt="simplepay logo and cards")
</template>
<script>
import VueButton from '@ui-common/vue-button';
import VueInput from '@ui-common/vue-input';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueCurrencyInput from '@ui-common/vue-currency-input';
import { required } from 'vuelidate/lib/validators';
import pattern from '../../../common/js/validators/pattern';
import email from '../../../common/js/validators/email';
import VueCaptcha from '@ui-common/vue-captcha';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueTooltip from '@ui-common/vue-tooltip';
import { MOBILE_PHONE_REGEXP, FORM_STATES } from '../../../common/js/constants/constants';
import { jumpToFirstError } from '../../../common/js/find-first-error-component/find-first-error-component';
import { errorHandlerUtils } from '../../../common/js/error-handler-utils/error-handler-utils';
const OTHER = 'OTHER';
const AMOUNT_VALUES = [
	{ key: 1000, value: '1 000 Ft' },
	{ key: 2000, value: '2 000 Ft' },
	{ key: 5000, value: '5 000 Ft' },
	{ key: OTHER, value: 'Más összeget adok meg' }
];
import { isMobile } from '@ui-common/sf-js-utils';
export default {
	mixins: [jumpToFirstError, errorHandlerUtils, isMobile],
	data: () => ({
		acceptPrivacyStatement: false,
		model: {
			mid: null,
			projectName: null,
			merchantName: null,
			amount: null,
			donorName: null,
			email: null,
			phoneNumber: null,
			captchaText: null
		},
		amount: 1000,
		amountOther: null
	}),
	provide() {
		return {
			$v: this.$v
		};
	},
	props: {
		captchaImg: {
			required: true
		},
		captchaError: {
			required: true
		},
		projectName: {
			required: true,
			type: String
		},
		merchantName: {
			required: true,
			type: String
		},
		mid: {
			required: true,
			type: String
		},
		formData: {
			required: true
		},
		formState: {
			required: true
		}
	},
	components: {
		VueInput,
		VueButton,
		VueRadioGroup,
		VueCurrencyInput,
		VueCaptcha,
		VueErrorMessage,
		VueMobilephoneInput,
		VueCheckbox,
		VueTooltip
	},
	validations() {
		return {
			amountOther: this.amount == OTHER ? { required } : {},
			acceptPrivacyStatement: {
				checked: value => value === true
			},
			model: {
				donorName: { required },
				email: {
					required,
					email
				},
				phoneNumber: {
					required,
					pattern: pattern(MOBILE_PHONE_REGEXP)
				},
				captchaText: this.captchaImg
					? {
							required
					  }
					: {}
			}
		};
	},
	watch: {
		amount: {
			handler(val) {
				if (val != OTHER) {
					this.model.amount = val;
				} else {
					this.model.amount = null;
				}
			},
			immediate: true
		},
		formData: {
			handler(val) {
				if (val) {
					this.model = Object.assign({}, this.model, val);
					if (val.amount) {
						if (AMOUNT_VALUES.map(amount => amount.key).includes(val.amount)) {
							this.amount = val.amount;
						} else {
							this.amountOther = val.amount;
							this.amount = OTHER;
						}
					}
				}
			},
			immediate: true
		},
		amountOther(val) {
			this.model.amount = val;
		},
		captchaError(val) {
			if (val) {
				this.jumpToFirstError();
			}
		}
	},
	computed: {
		AMOUNT_VALUES: () => AMOUNT_VALUES,
		FORM_STATES: () => FORM_STATES
	},
	methods: {
		send() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.jumpToFirstError();
			} else {
				const modelToSend = Object.assign({}, this.model, { mid: this.mid });
				this.$emit('submit', modelToSend);
			}
		},
		resetCaptcha() {
			this.model.captchaText = null;
			this.$v.model.captchaText.$reset();
		}
	},
	created() {
		this.model.projectName = this.projectName;
		this.model.merchantName = this.merchantName;
	}
};
</script>
<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.donation-form .sf-heading-2 {
	padding-left: 0;
	padding-right: 0;

	@include media('>=tablet') {
		padding-left: 60px;
		padding-right: 60px;
	}

	@include media('>=desktop') {
		padding-left: 84px;
		padding-right: 84px;
	}

	@include media('>=desktop-lg') {
		padding-left: 96px;
		padding-right: 96px;
	}
}

.donation-form .sf-text:first-of-type {
	margin-bottom: 48px;
}

.donation-form hr {
	display: none;

	@include media('>=tablet') {
		border-left: 0;
		border-right: 0;
		border-top: 0;
		display: block;
		height: 1px;
		margin-bottom: 32px;
		margin-left: 60px;
		margin-right: 60px;
	}

	@include media('>=desktop') {
		margin-left: 84px;
		margin-right: 84px;
	}

	@include media('>=desktop-lg') {
		margin-left: 96px;
		margin-right: 96px;
	}
}

.donation-form .dropdown-field {
	margin-bottom: 48px;
}

.donation-form .dropdown-field--arrow {
	margin-top: -32px;

	@include media('>=tablet') {
		margin-top: -40px;
	}
}

.donation-form .dropdown-field--arrow svg.dropdown-arrow {
	left: 20px;

	@include media('>=tablet', '<desktop') {
		left: 236px;
	}

	@include media('>=desktop') {
		left: 368px;
	}

	@include media('>=desktop-lg') {
		left: 380px;
	}
}

.donation-form > fieldset:first-of-type {
	@include media('>=tablet') {
		margin-bottom: 40px;
	}
}

.donation-form .sf-checkbox:last-of-type {
	margin-bottom: 0;

	@include media('>=tablet') {
		margin-bottom: 16px;
	}
}

.donation-form .form-row--submit-button {
	margin-bottom: 48px;

	@include media('>=tablet') {
		margin-bottom: 64px;
	}
}
.donation-form .form-row--simplepay {
	display: block;
	text-align: center;
}

.donation-form .form-row--simplepay .logo-cards {
	max-width: 736px;
	width: 100%;
}
</style>
